module.exports = __webpack_public_path__ + "static/media/ramenlegal_home.b12232b0.jpg";